/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { Zustellkennzeichen } from '../models';
/**
 * ZustellkennzeichenService - axios parameter creator
 * @export
 */
export const ZustellkennzeichenServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von Zustellkennzeichen
         * @summary Zustellkennzeichen
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZustellkennzeichen: async (mandant?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/zustellkennzeichen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mandant !== undefined) {
                localVarQueryParameter['mandant'] = mandant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZustellkennzeichenService - functional programming interface
 * @export
 */
export const ZustellkennzeichenServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZustellkennzeichenServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von Zustellkennzeichen
         * @summary Zustellkennzeichen
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZustellkennzeichen(mandant?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Zustellkennzeichen>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZustellkennzeichen(mandant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ZustellkennzeichenService - factory interface
 * @export
 */
export const ZustellkennzeichenServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZustellkennzeichenServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von Zustellkennzeichen
         * @summary Zustellkennzeichen
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZustellkennzeichen(mandant?: number, options?: any): AxiosPromise<Array<Zustellkennzeichen>> {
            return localVarFp.getZustellkennzeichen(mandant, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZustellkennzeichenService - interface
 * @export
 * @interface ZustellkennzeichenService
 */
export interface ZustellkennzeichenServiceInterface {
    /**
     * Liefert eine Liste von Zustellkennzeichen
     * @summary Zustellkennzeichen
     * @param {number} [mandant] mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZustellkennzeichenServiceInterface
     */
    getZustellkennzeichen(mandant?: number, options?: any): AxiosPromise<Array<Zustellkennzeichen>>;

}

/**
 * ZustellkennzeichenService - object-oriented interface
 * @export
 * @class ZustellkennzeichenService
 * @extends {BaseAPI}
 */
export class ZustellkennzeichenService extends BaseAPI implements ZustellkennzeichenServiceInterface {
    /**
     * Liefert eine Liste von Zustellkennzeichen
     * @summary Zustellkennzeichen
     * @param {number} [mandant] mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZustellkennzeichenService
     */
    public getZustellkennzeichen(mandant?: number, options?: any) {
        return ZustellkennzeichenServiceFp(this.configuration).getZustellkennzeichen(mandant, options).then((request) => request(this.axios, this.basePath));
    }
}
